import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

// Écrans hôtesse / responsable : mêmes bibliothèques que Supermont (Bootstrap 5 +
// Font Awesome). Elles ne sont chargées que sur ces écrans pour ne pas toucher au jeu.
const SHEETS = [
  { id: 'staff-bootstrap', href: 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css' },
  { id: 'staff-fontawesome', href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css' },
];

function useStaffSheets() {
  const [ready, setReady] = useState(() => SHEETS.every((s) => document.getElementById(s.id)?.dataset.loaded));
  useEffect(() => {
    let pending = SHEETS.length;
    const done = () => { pending -= 1; if (pending <= 0) setReady(true); };
    const links = SHEETS.map(({ id, href }) => {
      let link = document.getElementById(id);
      if (link) { if (link.dataset.loaded) done(); else link.addEventListener('load', done); return link; }
      link = document.createElement('link');
      link.id = id; link.rel = 'stylesheet'; link.href = href;
      link.addEventListener('load', () => { link.dataset.loaded = '1'; done(); });
      link.addEventListener('error', done);
      document.head.appendChild(link);
      return link;
    });
    const fallback = setTimeout(() => setReady(true), 4000); // réseau lent : on affiche quand même
    document.body.classList.add('staff');
    return () => {
      clearTimeout(fallback);
      document.body.classList.remove('staff');
      links.forEach((l) => l.remove());
    };
  }, []);
  return ready;
}

export default function StaffShell() {
  const ready = useStaffSheets();
  if (!ready) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f6f9', color: '#1565c0', fontWeight: 700 }}>
        CHARGEMENT...
      </div>
    );
  }
  return <Outlet />;
}
